/* jslint browser: true */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {toast} from 'react-toastify';
import validator from 'validator';
import $ from 'jquery';
import Jours from './Jours';
import Problemes from './Problemes';
import {apiUrl} from '../lib/constants';

/* ########### Froala WYSIWYG Editor ########### */
// Require Editor JS files.
import 'froala-editor/js/froala_editor.pkgd.min.js';

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Require Font Awesome.
import 'font-awesome/css/font-awesome.css';

import FroalaEditor from 'react-froala-wysiwyg';
window.jQuery = $;
window.$ = $;
/* ########### Froala WYSIWYG Editor ########### */

class FormMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu : {
                menu : {
                    nom          : '',
                    score        : 0,
                    priorite     : 0,
                    type         : 0,
                    compositions : '',
                    recette      : '',
                    actif        : false,
                    biotypologie : 0
                },
                jours     : [],
                problemes : []
            },
            priorityValues : [{nom: 'Très peu', value: 70}, {nom: 'Normal', value: 50}, {nom: 'Souvent', value: 25}]
        };
        this.handleChange = this.handleChange.bind(this);
        this.updateJours = this.updateJours.bind(this);
        this.updateProblemes = this.updateProblemes.bind(this);
        this.submitMenu = this.submitMenu.bind(this);
        this.editorConfig = {
            toolbarButtons  : ['fullscreen', 'bold', 'underline', 'strikeThrough', 'subscript', 'superscript', '|', 'fontFamily', 'fontSize', 'color', 'inlineClass', 'inlineStyle', 'paragraphStyle', 'lineHeight', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo', 'embedly', 'insertFile', 'insertTable', '|', 'emoticons', 'fontAwesome', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', '|', 'print', 'getPDF', 'spellChecker', 'help', 'html', '|', 'undo', 'redo'],
            enter           : $.FroalaEditor.ENTER_DIV,
            placeholderText : ""
        };
    }

    componentWillMount() {
        if(this.props.menuId !== undefined) {
            axios.get(`${apiUrl}/api/v1/admin/menu/${this.props.menuId}`).then((response) => {
                this.setState({
                    menu : response.data
                });
            });
        }
    }

    /**
     * Mes a jour un champ du menu en fonction de l'element HTML modifié
     * @param  {event} e Evenement (onChange) sur un champ du formulaire
     */
    handleChange(e, field) {
        const menu = this.state.menu;
        if(e.target === undefined && field !== undefined) {
            menu.menu[field] = e;
        } else if(e.target.name === 'actif') {
            menu.menu.actif = e.target.checked;
        } else {
            menu.menu[e.target.name] = e.target.value;
        }
        this.setState({menu});
    }

    /**
     * Met a jour les jours du menu
     * @param  {array} jours Contient les jours a affecter au menu
     */
    updateJours(jours) {
        const menu = this.state.menu;
        menu.jours = jours;
        this.setState({menu});
    }


    /**
     * Met a jours les probleme du menu
     * @param  {array} problemes Contient les problemes à affecter au menu
     */
    updateProblemes(problemes) {
        const menu     = this.state.menu;
        menu.problemes = problemes;
        this.setState({menu});
    }

    /**
     * Met a jours la recette du menu
     * @param  {string} value Contient le text du block Wysiwyg
     */
    updateWysiwyg(value) {
        const menu        = this.state.menu;
        menu.menu.recette = value;
        this.setState({
            menu
        });
    }

    /**
     * Envoi les données saisi dans le fomulaire au serveur pour l'enregistrer, si un id_menu est passé dans le menu a enregistrer,
     * le serveur met a jour le menu corespondant, sinon, il en créé un nouveau
     * @param  {event} e Evenement de l'envoi du formulaire
     */
    submitMenu(e) {
        e.preventDefault();
        if(validator.isEmpty(this.state.menu.menu.nom)) {
            toast.error('Séléctionnez un nom');
            return;
        }
        if(validator.equals(String(this.state.menu.menu.type), '0') || validator.equals(String(this.state.menu.menu.type), 0)) {
            toast.error('Séléctionnez un type');
            return;
        }
        if(validator.equals(String(this.state.menu.menu.priorite), '0') || validator.equals(String(this.state.menu.menu.priorite), 0)) {
            toast.error('Choisir une récurrence');
            return;
        }
        if(validator.isEmpty(this.state.menu.menu.compositions)) {
            toast.error('Saisir une composition');
            return;
        }
        axios.put(`${apiUrl}/api/v1/admin/menu`, this.state.menu).then((response) => {
            toast.success('Menu sauvegardé');
            this.props.loadData();
            this.props.closeModal();
        });
    }

    render() {
        const $recette = $("#recette.wysiwyg > textarea");
        if($recette) {
            if(this.state.menu.menu.type !== 5 && this.state.menu.menu.type !== '5') {
                $recette.froalaEditor("edit.off");
            } else {
                $recette.froalaEditor("edit.on");
            }
        }
        return (
            <div className="menu-form">
                <form style={{width: '95%', margin: '0 auto'}} onSubmit={e => this.submitMenu(e)}>
                    <div className="form-row">
                        <div className="form-nom">
                            <label htmlFor="nom">Nom
                                <input
                                    type="text"
                                    id="nom"
                                    name="nom"
                                    value={this.state.menu.menu.nom}
                                    onChange={e => this.handleChange(e)}
                                />
                            </label>
                        </div>
                        <div className="form-actif" style={{whiteSpace: 'nowrap'}}>
                            <label htmlFor="actif">Actif
                            </label>
                            <input
                                type="checkbox"
                                id="actif"
                                name="actif"
                                checked={this.state.menu.menu.actif}
                                onChange={e => this.handleChange(e)}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-column">
                            <div className="form-type">
                                <label htmlFor="type">Type
                                </label>
                                <select
                                    onChange={e => this.handleChange(e)}
                                    name="type"
                                    id="type"
                                    value={this.state.menu.menu.type}
                                >
                                    <option value="0" disabled>--</option>
                                    <option value="1">Petit-Déjeuner</option>
                                    <option value="2">Collation de 10h</option>
                                    <option value="3">Déjeuner</option>
                                    <option value="4">Collation de 16h</option>
                                    <option value="5">Dîner</option>
                                    {/* <option value="6">Déjeuné rapide</option> */}
                                </select>
                            </div>
                            <div className="form-priorite">
                                <label htmlFor="priorite">Récurrence
                                </label>
                                <select
                                    name="priorite"
                                    id="priorite"
                                    onChange={e => this.handleChange(e)}
                                    value={this.state.menu.menu.priorite}
                                >
                                    <option value="0" disabled>--</option>
                                    <option value={this.state.priorityValues[0].value}>{this.state.priorityValues[0].nom}</option>
                                    <option value={this.state.priorityValues[1].value}>{this.state.priorityValues[1].nom}</option>
                                    <option value={this.state.priorityValues[2].value}>{this.state.priorityValues[2].nom}</option>
                                </select>
                            </div>
                        </div>
                        <Jours width="70%" model={this.state.menu.jours} updateJours={this.updateJours} />
                    </div>
                    <div className="form-row">
                        <h4>Composition</h4>
                        <div id="compositions" className="wysiwyg">
                            <FroalaEditor
                                tag="textarea"
                                config={this.editorConfig}
                                model={this.state.menu.menu.compositions}
                                onModelChange={model => this.handleChange(model, "compositions")}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <Problemes model={this.state.menu.problemes} updateProblemes={this.updateProblemes} />
                    </div>
                    <div className="form-row">
                        <h4>Recette associée</h4>
                        <div id="recette" className="wysiwyg">
                            <FroalaEditor
                                tag="textarea"
                                config={this.editorConfig}
                                model={this.state.menu.menu.recette}
                                onModelChange={model => this.handleChange(model, "recette")}
                            />
                        </div>
                    </div>

                    <button type="button" className="btn myBtn myBtnCancel pull-left" onClick={e => this.props.closeModal(e)}>Annuler</button>
                    <button type="submit" className="btn myBtn pull-right">Sauvegarder</button>
                </form>
            </div>
        );
    }
}

// Declaration des props du composant
FormMenu.propTypes = {
    menuId     : PropTypes.number,
    closeModal : PropTypes.func,
    loadData   : PropTypes.func
};
// Définition par defaut (si non-attribué a l'appel du composant) des props
FormMenu.defaultProps = {
    menuId     : undefined,
    closeModal : () => undefined,
    loadData   : () => undefined
};

export default FormMenu;


// WEBPACK FOOTER //
// ./src/components/FormMenu.js